import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackSetupStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GuestFeedbackSetupStatusQuery = { __typename?: 'Query', GuestFeedbacks: { __typename?: 'GuestFeedbacks', totalCount: number }, OrgGuestFeedbackIntegrations: Array<{ __typename?: 'OrgGuestFeedbackIntegration', id: string }>, OrgGuestFeedbackCsvUploads: { __typename?: 'OrgGuestFeedbackCsvUploads', totalCount: number } };


export const GuestFeedbackSetupStatusDocument = gql`
    query GuestFeedbackSetupStatus {
  GuestFeedbacks(input: {}, pagination: {limit: 1}) {
    totalCount
  }
  OrgGuestFeedbackIntegrations {
    id
  }
  OrgGuestFeedbackCsvUploads {
    totalCount
  }
}
    `;

/**
 * __useGuestFeedbackSetupStatusQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackSetupStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackSetupStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackSetupStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestFeedbackSetupStatusQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackSetupStatusQuery, GuestFeedbackSetupStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackSetupStatusQuery, GuestFeedbackSetupStatusQueryVariables>(GuestFeedbackSetupStatusDocument, options);
      }
export function useGuestFeedbackSetupStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackSetupStatusQuery, GuestFeedbackSetupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackSetupStatusQuery, GuestFeedbackSetupStatusQueryVariables>(GuestFeedbackSetupStatusDocument, options);
        }
export type GuestFeedbackSetupStatusQueryHookResult = ReturnType<typeof useGuestFeedbackSetupStatusQuery>;
export type GuestFeedbackSetupStatusLazyQueryHookResult = ReturnType<typeof useGuestFeedbackSetupStatusLazyQuery>;
export type GuestFeedbackSetupStatusQueryResult = Apollo.QueryResult<GuestFeedbackSetupStatusQuery, GuestFeedbackSetupStatusQueryVariables>;